import FormattedMessage from 'I18n/components/FormattedMessage';
import EmptyStateWithIllustration from '../../../components/content/EmptyStateWithIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
const DealCardEmptyState = () => {
  return /*#__PURE__*/_jsx(EmptyStateWithIllustration, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.emptyState.DEAL"
    })
  });
};
export default DealCardEmptyState;